/** EU Food Information Regulation (1169/2011) Annex II — the 14 declarable allergens. */
export const EU_ALLERGENS = [
  { id: 'celery', label: 'Celery', value: 'celery' },
  {
    id: 'cereals-gluten',
    label: 'Cereals containing gluten',
    value: 'cereals containing gluten',
  },
  { id: 'crustaceans', label: 'Crustaceans', value: 'crustaceans' },
  { id: 'eggs', label: 'Eggs', value: 'eggs' },
  { id: 'fish', label: 'Fish', value: 'fish' },
  { id: 'lupin', label: 'Lupin', value: 'lupin' },
  { id: 'milk', label: 'Milk', value: 'milk' },
  { id: 'molluscs', label: 'Molluscs', value: 'molluscs' },
  { id: 'mustard', label: 'Mustard', value: 'mustard' },
  { id: 'nuts', label: 'Nuts (tree nuts)', value: 'nuts' },
  { id: 'peanuts', label: 'Peanuts', value: 'peanuts' },
  { id: 'sesame', label: 'Sesame', value: 'sesame' },
  { id: 'soybeans', label: 'Soybeans', value: 'soybeans' },
  {
    id: 'sulphites',
    label: 'Sulphur dioxide and sulphites',
    value: 'sulphur dioxide and sulphites',
  },
] as const;

export type EuAllergenValue = (typeof EU_ALLERGENS)[number]['value'];

export function allergenLabel(value: string): string {
  const match = EU_ALLERGENS.find(
    (a) => a.value.toLowerCase() === value.toLowerCase(),
  );
  return match?.label ?? value;
}
